import { hostedModelReasoningLevelSchema, modelCatalogBadgeLabelSchema } from "../config/model-catalog.js";
import * as z$1 from "zod/v4";
//#region src/schemas/runtime/center-agent-model.ts
const boundedIdentifierSchema = z$1.string().trim().min(1).max(256);
const centerAgentModelPreferenceSchema = z$1.discriminatedUnion("kind", [z$1.strictObject({ kind: z$1.literal("system_default") }), z$1.strictObject({
	kind: z$1.literal("selected_model"),
	modelId: boundedIdentifierSchema
})]);
const centerAgentModelSummarySchema = z$1.strictObject({
	availability: z$1.enum([
		"available",
		"unavailable",
		"unknown"
	]),
	displayName: boundedIdentifierSchema,
	modelId: boundedIdentifierSchema,
	supportsImageInput: z$1.boolean()
});
const centerAgentModelChoiceSchema = z$1.strictObject({
	badgeLabel: modelCatalogBadgeLabelSchema.nullable().optional(),
	displayName: boundedIdentifierSchema,
	effectiveModelDisplayName: boundedIdentifierSchema,
	preference: centerAgentModelPreferenceSchema,
	supportsImageInput: z$1.boolean()
});
const centerAgentHostedModelRouteSchema = z$1.strictObject({
	contextWindow: z$1.number().int().positive(),
	displayName: boundedIdentifierSchema,
	inputModalities: z$1.array(z$1.enum(["text", "image"])).min(1),
	maxOutputTokens: z$1.number().int().positive(),
	modelId: boundedIdentifierSchema,
	provider: z$1.literal("openrouter"),
	reasoningLevel: hostedModelReasoningLevelSchema
});
const centerAgentModelRouteSchema = z$1.strictObject({
	automaticModelFallback: z$1.literal(false),
	catalogUpdatedAt: z$1.iso.datetime({ offset: true }),
	contextWindow: z$1.number().int().positive(),
	displayName: boundedIdentifierSchema,
	imageUnderstandingModel: centerAgentHostedModelRouteSchema,
	inputModalities: z$1.array(z$1.enum(["text", "image"])).min(1),
	maxOutputTokens: z$1.number().int().positive(),
	modelId: boundedIdentifierSchema,
	preference: centerAgentModelPreferenceSchema,
	provider: z$1.literal("openrouter"),
	reasoningLevel: hostedModelReasoningLevelSchema
});
//#endregion
export { centerAgentModelChoiceSchema, centerAgentModelPreferenceSchema, centerAgentModelRouteSchema, centerAgentModelSummarySchema };

//# sourceMappingURL=center-agent-model.js.map